class HeaderController {
  constructor (Localization, I18n, $state, $rootScope, $scope, UserService, VehicleService, $log) {
    'ngInject'
    this.I18n = I18n
    this.locales = Localization.getLocalizedAppConfig().locales
    this.passwordExpirationDay = Localization.getLocalizedAppConfig().passwordExpirationDay
    this.userService = UserService
    this.vehicleService = VehicleService
    this.$state = $state
    this.$log = $log
    this.$rootScope = $rootScope
    $scope.$on('user:login', (event, data) => {
      this.init()
      .then(() => {
        this.$rootScope.$broadcast('checkDocumentConsent:on')
      })
    })
    $scope.$on('user:logout', (event, data) => {
      this.user = null
      this.vehicles = null
      this.vehicle = null
      this.$rootScope.$broadcast('checkDocumentConsent:off')
    })
    $scope.$on('vehicles:update', (event, data) => {
      this.vehicleService.getCurrentUserVehicles()
      .then((vehicles) => {
        this.vehicles = vehicles
        return this.vehicleService.getCurrentSelectedVehicle()
      })
      .then((vehicle) => {
        this.vehicle = vehicle
      })
      .catch((err) => {
        this.$log.error('Unable to load HeaderController', err)
      })
    })
    this.loaded = this.init()
  }

  init () {
    if (!this.userService.getCurrentToken()) {
      return Promise.resolve()
    }
    return this.userService.getCurrentUser()
    .then((user) => {
      this.user = user
      this.$log.debug('Header user: ', user)
      if (this.userService.isPasswordExpired(user.lastPasswordUpdate, this.passwordExpirationDay)) {
        this.$log.debug('Header password expired')
        return Promise.reject({passwordExpired: true})
      } else {
        this.$log.debug('Header password not expired')
        return this.vehicleService.synchronizeCurrentUserVehicles()
      }
    }).then(() => {
      this.$log.info('Vehicles synchronized from CSDB')
      return this.vehicleService.getCurrentUserVehicles(false)
    }, (err) => {
      this.$log.error('Vehicles not synchronized from CSDB', err)
      if (err && err.passwordExpired) {
        return Promise.reject()
      } else {
        return this.vehicleService.getCurrentUserVehicles(false)
      }
    })
    .then((vehicles) => {
      this.vehicles = vehicles
      return this.vehicleService.getCurrentSelectedVehicle(false)
    })
    .then((vehicle) => {
      this.vehicle = vehicle
    })
    .catch((err) => {
      if (err && !err.passwordExpired) {
        this.user = null
      }
      this.vehicles = null
      this.vehicle = null
      this.$log.error('Unable to load HeaderController', err)
    })
  }

  returnHome () {
    document.location = document.location.origin
  }

  get locale () {
    return this.I18n.getLanguage()
  }

  set locale (locale) {
    this.I18n.changeLanguage(locale)
  }

  isMaintenance () {
    return this.$state.is('maintenance')
  }

  handleLogout () {
    this.userService.logout()
    .then(() => {
      return this.$state.go('home')
    })
  }
}

export default HeaderController



// WEBPACK FOOTER //
// ./src/app/common/header/header.controller.js